import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../core/services/language.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-error',
  imports: [TranslateModule, CommonModule],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  languageService = inject(LanguageService);

  code!: string;
  rtl: boolean = true;   
  rtlSub!: Subscription;

  constructor(private route: ActivatedRoute, private router: Router) {
       this.rtlSub = this.languageService.rtl$.subscribe((isRtl) => {
    this.rtl = isRtl;       
  });

  }

  ngOnInit(): void {
    this.code = this.route.snapshot.data['code'];

    this.route.data.subscribe(data => {
      this.code = data['code'];
    });
  }
   retry() {
    window.location.reload();
  }

  goHome() {
    this.router.navigate(['/dashboard']);
  }
   ngOnDestroy() {
    this.rtlSub.unsubscribe();
  }
}
